import { render, staticRenderFns } from "./reserve_ledger.vue?vue&type=template&id=63a59687&scoped=true&"
import script from "./reserve_ledger.vue?vue&type=script&lang=js&"
export * from "./reserve_ledger.vue?vue&type=script&lang=js&"
import style0 from "./reserve_ledger.vue?vue&type=style&index=0&id=63a59687&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a59687",
  null
  
)

export default component.exports